import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ParametrosAPI } from "../../http-requests";

type PluginPayload = {
    src?: string;
    code?: string;
};

const parsePluginPayload = (plugin: string): PluginPayload | null => {
    const value = plugin?.trim();
    if (!value) {
        return null;
    }

    if (/^https?:\/\//i.test(value) || value.startsWith("/")) {
        return { src: value };
    }

    if (/^<script[\s>]/i.test(value)) {
        const doc = new DOMParser().parseFromString(value, "text/html");
        const scriptTag = doc.querySelector("script");

        if (!scriptTag) {
            return null;
        }

        const src = scriptTag.getAttribute("src")?.trim();
        if (src) {
            return { src };
        }

        const code = scriptTag.textContent?.trim();
        return code ? { code } : null;
    }

    if (/^<!doctype html>|^<html[\s>]/i.test(value)) {
        return null;
    }

    return { code: value };
};

const AppExternalPluginLoader: React.FunctionComponent = () => {

    const [pluginSrc, setPluginSrc] = useState<string | null>(null);
    const { p } = useSelector((state: any) => state.instituicao.data);

    useEffect(() => {
        if (p && p.__custom_plugin) {
            ParametrosAPI.buscaPluginCustomizado()
                .then(response => {
                    if (response.data && response.data.plugin) {
                        setPluginSrc(response.data.plugin);
                    }
                })
                .catch(error => {
                    console.error("Error loading external plugin:", error);
                });
        }
    }, [p]);

    useEffect(() => {
        if (pluginSrc) {
            const body = document.querySelector("body");
            if (body) {
                const payload = parsePluginPayload(pluginSrc);
                if (!payload) {
                    console.error("Invalid external plugin payload. Expected JS code, script tag, or URL.");
                    return;
                }

                const script = document.createElement("script");
                script.async = true;

                if (payload.src) {
                    script.src = payload.src;
                } else {
                    script.text = payload.code ?? "";
                }

                body.appendChild(script);

                return () => {
                    script.remove();
                };
            }
        }
    }, [pluginSrc]);

    return <input type="hidden" id="external_plugin_loader" value="true" />;
};

export default AppExternalPluginLoader;